import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + heroSlides.length) % heroSlides.length);
  };

  return (
    <section className="relative h-[440px] w-full overflow-hidden md:h-[580px]">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点推荐`}
            title={`${slide.title} - 恋爱影视焦点推荐`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50"></div>
        </div>
      ))}

      <div className="relative z-10 flex h-full w-full items-center px-4 md:px-8">
        <div className="mx-auto w-full max-w-[1280px]">
          <div key={heroSlides[index].id} className="max-w-xl animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-fill"></i>
              {heroSlides[index].subtitle}
            </span>
            <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
              {heroSlides[index].title}
            </h1>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-white/85 md:text-base">
              {heroSlides[index].desc}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${heroSlides[index].movieId}`}
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-play-fill text-lg"></i>
                查看剧情详情
              </Link>
              <Link
                to="/category/电视剧"
                className="inline-flex items-center gap-2 rounded-md border border-white/60 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/15 whitespace-nowrap"
              >
                浏览全部作品
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/40 text-white transition-colors hover:bg-foreground-950/70 md:left-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/40 text-white transition-colors hover:bg-foreground-950/70 md:right-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all ${
              i === index ? "w-6 bg-primary-400" : "w-2 bg-white/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}